import React, {useEffect, useState} from "react";
import {
    Card,
    Box,
    Typography,
    Button,
    TextField, InputAdornment, Tooltip, IconButton,
} from "@mui/material";
import Table from "./Table";
import {getPermissionsFilter, getRolePermissions} from "./rolesApi";
import {useDispatch} from "react-redux";
import {setPermissions} from "../../store/permissionsSlice";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import {useSearchParams} from "react-router-dom";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function Roles(){
    const [_,setSearch] = useSearchParams();
    
    const dispatch = useDispatch();
    const [search,setSearchString] = useState(_.get('search'));
    useEffect(()=>{
        getPermissionsFilter()
            .then(({data})=>{
                dispatch(setPermissions(data))
            });
    },[]);
    return <Box>
        <Card>
            <Box py={2}>
                <Box px={2}>
                    <Box sx={{
                        display:'flex',
                        justifyContent:'space-between',
                        alignItems:'center'
                    }}>
                        <Typography fontSize={18} fontWeight={600}>
                            Roles
                        </Typography>
                    </Box>
                    <Box display={'flex'} gap={2} pt={2} flexWrap={'wrap'}>
                        <TextField
                            label={'Search by name'}
                            value={search}
                            onChange={(e)=>{
                               setSearchString(e.target.value) 
                            }}
                            InputProps={{
                                endAdornment:<InputAdornment position={'end'}>
                                    <Tooltip title={'Clear search'} arrow>
                                        <IconButton
                                            size={"small"}
                                            onClick={()=>{
                                                setSearchString('')
                                                setSearch(``)
                                            }}
                                        >
                                            <CloseRoundedIcon fontSize={"small"} />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            }}
                        />
                        <Button
                            onClick={()=>{
                                setSearch(`?search=${search}`)
                            }}
                            endIcon={<SearchRoundedIcon/>}>
                            Search
                        </Button>
                    </Box>
                </Box>
                <Table/>
            </Box>
        </Card>
    </Box>
}